
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import './App.css';
import './media.css';
import { LanguageProvider } from "./context/LanguageContext";
import { RenderRout } from './router';
window.bootstrap = bootstrap;
function App() {
  return (
    <LanguageProvider>
      <RenderRout/>
    </LanguageProvider>
 
  );
}

export default App;
